<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Tipos Atividades" />

      <Lynx-Button
        text="Cadastrar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="showModalTipoAtividade()"
      />
      
      <Lynx-Button
        text="Voltar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="voltar()"
      />
    </div>

    <b-table
      :columns="columns"
      :data="lista_tipos_atividade"
      paginated
      per-page="10"
    >
      <template slot-scope="props" v-if="props.row.id != null">
        <b-table-column field="id">
          {{ props.row.nome.toUpperCase() }}
        </b-table-column>

        <b-table-column field="colunas">
          {{ JSON.parse(props.row.colunas).join(", ") }}
        </b-table-column>

        <b-table-column field="tipo">
          {{ props.row.tipo }}
        </b-table-column>
              <b-table-column field="setor">
          {{ props.row.setor }}
        </b-table-column>
        <b-table-column field="subSetor">
          {{ props.row.sub_setor }}
        </b-table-column>

        <b-table-column field="created_at">
          {{ props.row.created_at | formatEnToBr }}
        </b-table-column>

        <b-table-column field="acoes">
          <div class="flex text-sm">
            <div class="flex text-sm items-center">
              <Lynx-Button
                class=""
                icon-size="7"
                text="Atualizar"
                size="small"
                @click.native="atualizar(props.row)"
              />
              <!-- <Lynx-Button
                class=""
                icon-size="7"
                icon="Trash"
                size="small"
                @click.native="confirmDelete(props.row)"
              /> -->
            </div>
          </div>
        </b-table-column>
      </template>
      <template v-slot:empty>
        <NotFoundData text="Nenhum tipo encontrado!" />
      </template>
    </b-table>

    <b-modal :active.sync="modalTipoAtividade" :width="600">
      <div class="bg-white p-5" style="height: 650px">
        <Lynx-Title text="Competência da Planilha" />

        <div>
          <Lynx-Label label="Tipo" />
          <Lynx-Input
            v-model="form.nome"
            placeholder="Digite o nome do tipo atividade"
          />
        </div>
        <div class="mt-2">
          <Lynx-Label label="Selecione colunas" />
          <treeselect
            :multiple="true"
            :options="lista_colunas"
            placeholder="Selecione as colunas..."
            v-model="colunas"
          />
        </div>
        <div class="mt-2">
          <Lynx-Label label="Selecione regime tributario" />
          <treeselect
            :multiple="true"
            :options="lista_regime_tributario"
            placeholder="Selecione as colunas..."
            v-model="regimes_tributario"
          />
        </div>
        <div>
          <Lynx-Label label="Arquivo" />
          <b-switch v-model="form.arquivo" type="is-primary" />
        </div>
        <div class="mt-2">
          <Lynx-Label label="Tipo" />
          <treeselect
            :multiple="false"
            :options="lista_tipo"
            placeholder="Selecione o tipo..."
            v-model="form.tipo"
          />
        </div>
        <div class="w-full flex grid grid-cols-2 gap-2">
          <div class="mt-2">
            <Lynx-Label label="Setor" />
            <treeselect
              :multiple="false"
              :options="lista_setor"
              placeholder="Selecione o setor..."
              v-model="form.setor"
              @input="form.sub_setor = null"
            />
          </div>
          <div class="mt-2">
            <Lynx-Label label="Sub Setor" />
            <treeselect
              :multiple="false"
              :options="lista_sub_setor"
              placeholder="Selecione o sub setor..."
              v-model="form.sub_setor"
            />
          </div>
        </div>
        <div class="mt-2">
          <Lynx-Label label="Regra Acesso" />
          <treeselect
            :multiple="false"
            :options="lista_regras_acesso"
            placeholder="Selecione a regra acesso..."
            v-model="form.regra_acesso"
          />
        </div>
      </div>
      <footer class="modal-card-foot flex justify-between">
        <b-button
          @click.native="hideModalTipoAtividade()"
          type="is-danger"
          class="mt-4"
          >Cancelar</b-button
        >
        <b-button
          @click.native="confirm(!lista_campos.id ? 'cria' : 'edita')"
          type="is-primary"
          class="ml-4 mt-4"
          >Salvar</b-button
        >
      </footer>
    </b-modal>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";
import { monthNames } from "@/utils/utils";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import {
  TiposEnum,
  SetoresEnum,
  CsSubSetoresEnum,
  LegalizacaoSubSetoresEnum,
  ContabilidadeSubSetoresEnum,
} from "@/utils/enum";

export default {
  components: { NotFoundData, Treeselect },
  data() {
    return {
      monthNames,
      form: {
        colunas: [],
        regime_tributario: [],
        arquivo: false,
        nome: "",
        tipo: null,
        setor: null,
        sub_setor: null,
        regra_acesso: null,
      },
      modalTipoAtividade: false,
      selectedFiles: [],
      loading: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      lista_campos: [],
      preciona: 0,
      editavel: 0,
      regimes_tributario: [],
      tipo: null,
      setor: null,
      regra_acesso: null,
      colunas: [],

      columns: [
        {
          field: "tipo",
          label: "tipo",
          sortable: true,
        },

        {
          field: "colunas",
          label: "colunas",
        },

        {
          field: "tipo",
          label: "tipo",
        },
        {
          field: "setor",
          label: "setor",
        },
        {
          field: "sub_setor",
          label: "Sub setor",
        },
        {
          field: "created_at",
          label: "criação",
        },
        {
          field: "acoes",
          label: "Ações",
        },
      ],

      lista_regime_tributario: [
        { id: "SN", label: "Simples Nacional" },
        { id: "Presumido", label: "Lucro Presumido" },
        { id: "Isento", label: "Isento" },
        {
          id: "Eand",
          label: "Aguardando enquadramento no simples",
        },
        { id: "Presumido_equi", label: "presumido com equiparação" },
        {
          id: "MEI",
          label: "Microempreendedor Individual (MEI)",
        },
      ],

      lista_regras_acesso: [{ id: "super-admin", label: "Super Admin" }],
      lista_sub_setor: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),

    lista_tipos_atividade() {
      return this.$store.state.tipoAtividade.lista_tipos_atividade;
    },
    mensagem_alert() {
      return this.$store.state.tipoAtividade.mensagem_alert;
    },
    lista_colunas() {
      return this.$store.state.tipoAtividade.lista_colunas.map((coluna) => {
        return {
          id: coluna,
          label: coluna,
        };
      });
    },
    lista_tipo() {
      return TiposEnum;
    },
    lista_setor() {
      return SetoresEnum;
    },
  },

  watch: {
    'form.setor': function (value) {
      console.log(value);
   
      let subSetores = [];
      switch (value) {
        case "contabilidade":
          subSetores = ContabilidadeSubSetoresEnum;
          break;
        case "legalizacao e onboarding":
          subSetores = LegalizacaoSubSetoresEnum;
          break;
        case "cs":
          subSetores = CsSubSetoresEnum;
          break;
        default:
          subSetores = [];
      }
      this.lista_sub_setor = subSetores;
    },
  },

  mounted() {
    this.listar_tipos_atividade();
    this.litar_colunas();
  },
  filters: {
    formatEnToBr,
  },
  methods: {
    hasRole,

    hideModalTipoAtividade() {
      this.modalTipoAtividade = false;
    },

    showModalTipoAtividade() {
      this.modalTipoAtividade = true;
    },

    async confirm(tipo) {
      if (!this.hasRole("super-admin")) {
        this.$snack.error("Você não tem permissão para realizar esta ação");
      } else {
        this.form.colunas = JSON.stringify(this.colunas);
        this.form.regime_tributario = JSON.stringify(this.regimes_tributario);
        await this.$buefy.dialog.confirm({
          message: `Esta ação  ` + tipo + ` um tipo de atividade no sistema?`,
          confirmText: "Sim",
          cancelText: "Não",
          type: "is-success",
          onConfirm: () => {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          },
        });
      }
    },

    async create() {
      this.loading = true;

      this.$store.dispatch("configEmpresa/atualizar", "");
      await this.$store
        .dispatch("tipoAtividade/create_tipo_atividade", this.form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.hideModalTipoAtividade();
        })
        .catch((error) => this.$snack.error(mensagem_alert.message))
        .finally(() => (this.loading = false));
    },

    async update() {
      this.loading = true;
      this.$store.dispatch("configEmpresa/atualizar", "");

      await this.$store
        .dispatch("tipoAtividade/update_tipo_atividade", this.form)

        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.hideModalTipoAtividade();
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));
    },
    async listar_tipos_atividade() {
      this.loading = true;
      await this.$store.dispatch("tipoAtividade/listar_tipos_atividade");
      this.loading = false;
    },
    async litar_colunas() {
      await this.$store.dispatch("tipoAtividade/listar_colunas");
    },
    atualizar(value) {
      this.lista_campos = value;
      this.form = {
        id: value.id,
        nome: value.nome,
        arquivo: value.arquivo,
        tipo: value.tipo,
        setor: value.setor,
        sub_setor: value.sub_setor,
        regra_acesso: value.regra_acesso,
      };

      this.regimes_tributario = value.regime_tributario
        ? JSON.parse(value.regime_tributario)
        : [];
      this.colunas = JSON.parse(value.colunas);
      this.showModalTipoAtividade();
    },

    voltar(){
      this.$router.push({ name: "ativiades-competencia.index", params: {setor:this.$route.params.setor} });
    }
  },
};
</script>

<style scoped>
</style>
  